import React from 'react';
import ReactDOM from 'react-dom';
import HttpsRedirect from 'react-https-redirect';
import whyDidYouRender from '@welldone-software/why-did-you-render';

import App from './App';

import { Auth0Provider } from './utils/auth0';

const AUTH0_CONSTANTS = require('./constants/AUTH0.gen.json');
const AUTH0 = AUTH0_CONSTANTS[process.env.REACT_APP_RUNTIME];

// Enable for detailed console telemetry on every component re-render
const enableTelemetry = false;

if (enableTelemetry && process.env.REACT_APP_RUNTIME === 'development') {
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    collapseGroups: true,
    titleColor: 'green',
    diffPathColor: 'lightgray',
    diffNameColor: 'darkturquoise',
  });
}

ReactDOM.render(
  <HttpsRedirect disabled={process.env.REACT_APP_HTTPS_ENFORCEMENT !== 'true'}>
    <Auth0Provider
      domain={AUTH0.DOMAIN}
      client_id={AUTH0.REACT_APP_AUTH0_CLIENT_ID}
      redirect_uri={`${window.location.origin}?type=auth0`}
      audience={AUTH0.AUDIENCE}
      cacheLocation="localstorage"
      useRefreshTokens>
      <App enableAuth0 />
    </Auth0Provider>
  </HttpsRedirect>,
  document.getElementById('root')
);
